define('modules/form_editor/views/editor_text',['require','exports','module','base/view','ldsh!../templates/editor_text'],function(require,exports,module){
  "use strict";
  var BaseView = require("base/view");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_text"),
    events: {
      "change .js-placeholder": "updateModel"
    },
    updateModel: function(e){
      e.preventDefault();
      this.model.set("placeholder", $(e.currentTarget).val().trim());
    },
    onRender: function(){
      this.$el.i18n();
    }
  });
});

